<template>
	<div class="main bgwhite" v-title data-title="零部件企业">
		<iHeader ref="loginIndex" :message="msg"></iHeader>
		<div class="flexRow justBetween barprebox mt20">
			<div class="contL">
				<el-row class="tac">
					<el-col>
						<div class="menu">
							<el-menu :background-color="backgroundColor" :text-color="textColor"
								:default-active="deactive" :collapse="collapse" :default-openeds="deaopen"
								@select="handleSelect">
								<template v-for="item in list">
									<el-menu-item :index="item.id.toString()">
										<template slot="title">
											<span>{{item.name}}</span>
										</template>
									</el-menu-item>
								</template>
							</el-menu>
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="contR bgwhite borderL">
				<div class="mt25 ml20">
					<div v-if="pageShow==true">
						<div class="demo-image curhand">
							<div v-for="(item,index) in Ginfo" style="display: inline-block;">
								<div v-for="(item1,index1) in item.zizhi_url" style="display: inline-block; padding:10px">
									<el-image style="width: 190px; height: 240px"
										:src="item1.url" @click="bigImg(item1.url)">
									</el-image>
								</div>
							</div>
						</div>
					</div>
					<div class="txc mt25" v-else>
						<i class="iconfont icon-icon-no-data"></i>
						<p  style="padding-top: 10px;">暂无数据</p>
					</div>

				</div>
			</div>
		</div>
		<v-footer></v-footer>
		<!-- 图片放大 -->
		<el-dialog :visible.sync="dialogTableVisible">
		   <el-image :src="bigurl" >
		   </el-image>
		</el-dialog>
	</div>
</template>
<script>
	// 公共头部组件
	import Cookies from 'js-cookie'
	import iHeader from "@/components/indexheader"
	import vFooter from "@/components/Footer"
	import subMenu from "@/components/leftmenu"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	export default {
		components: {
			iHeader,
			vFooter,
			subMenu
		},
		data() {
			return {
				titleDec: "",
				handLoc: [],
				Ginfo: [],
				currentPage1: 5,
				inputS: '',
				collapse: false, //是否折叠
				backgroundColor: "#ffffff", //导航菜单背景颜色
				textColor: "#6c6e6f", //导航菜单文字颜色
				logo: "LOGO", //logo,
				list: [],
				default_openeds_array: [],
				pageShow:true,
				// 顶级id
				firstID: '',
				deactive: '1',
				deaopen: [],
				allcate: false,
				msg: "company",
				Ginfo1: ['https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg'],
				bigurl:'',
				dialogTableVisible:false
			}
		},
		created() {
			this.cateid = this.$route.query.cateid
			this.deaopen.push(this.$route.query.cateid)
			this.deactive = this.cateid;
			this.catelist();
			this.handleSelect();
		},
		methods: {
			handOpen() {
				this.deactive = this.cateid.toString();
			},
			catelist() {
				this.$postcn('partshome/zizhiType', {}, this).then((res) => {
					this.list = res.data;
					this.firstID = res.data[0].id;
				})
			},
			jumpurl(id, Ctype) {
				let routeData;
				if (Ctype == 1) {
					routeData = this.$router.resolve({
						path: "/gb/gbcont",
						query: {
							goodsid: id
						}
					})
				} else {
					routeData = this.$router.resolve({
						path: "/content",
						query: {
							goodsid: id
						}
					})
				}
				window.open(routeData.href, '_blank');
			},
			toggleChildren(item) {
				item.expanded = !item.expanded;
			},
			handleSelect(key, keyPath) {
				let param = {
					userid: Cookies.get('cuserid'),
					typeid: key
				}
				this.$postcn('partshome/zizhilist', param, this).then((res) => {
					if(res.data.length>0){
						this.pageShow=true
						this.Ginfo = res.data;
					}else if(res.data.code==-4004){
						this.$refs.loginIndex.handLogin(window.location.href)
					}else{
						this.pageShow=false
					}
					
				})
			},
			bigImg(url){
				this.dialogTableVisible=true;
				this.bigurl=url;
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.el-breadcrumb {
		height: 62px;
		line-height 62px !important;
		font-size: 14px;
	}

	.el-breadcrumb__inner,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
		color: #9298a2
	}
   .icon-icon-no-data {
   	font-size: 66px;
   	margin-top: 50px;
   	display: inline-block;
   	margin-bottom: 30px;
   }
	.el-submenu {
		width: 100%
	}

	.el-menu--popup-bottom-start {
		margin-top: 0px !important;
	}

	.el-menu--popup-right-start {
		margin: 0px !important;
	}

	.blockInfocate {
		padding: 10px 10px 20px 10px;
		text-align: center;
		display: inline-block;
		width: 245px;
		margin: 10px;
		box-sizing: border-box;
		vertical-align: top;
		background-color: #fafafa;
		border: 1px solid #eaeaea;
	}

	.h10 {
		height: 30px;
	}

	.demonstration {
		letter-spacing: 0;
		overflow: hidden;
		display: -webkit-box;
		text-overflow: ellipsis;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		line-height: 20px;
		width: 100%;
	}

	.el-submenu__icon-arrow {
		right: 10px;
	}

	.Cinput {
		display: inline-block !important;
		width: 300px !important;
	}

	.item1 {
		display: inline-block;
	}

	.Tnum {
		display: inline-block;
		float: left;
		margin-left: 10px;
		line-height: 40px;
	}

	.smallt {
		margin-right: 25px;
		height: 40px;
	}

	.active {
		border-color: #1f75cf;
		color: #1f75cf;
	}

	.el-submenu .el-menu-item,
	.el-submenu__title {
		overflow: hidden;
		/*超出部分隐藏*/
		text-overflow: ellipsis;
		/* 超出部分显示省略号 */
		white-space: nowrap;
		/*规定段落中的文本不进行换行 */
		// width: 220px;
	}

	.overtitle {
		overflow: hidden;
		/*超出部分隐藏*/
		text-overflow: ellipsis;
		/* 超出部分显示省略号 */
		white-space: nowrap;
		/*规定段落中的文本不进行换行 */
		width: 240px;
	}

	.Wactive {
		width: 190PX;
		cursor: pointer;
		transform: scale(1.5, 1.5)
	}

	.borderL {
		border-left: 1px solid #ccc;
	}
</style>
<style>
	.el-input--prefix .el-input__inner {
		padding-left: 30px !important;
	}

	.tac .el-menu {
		border-right: none;
	}
</style>



// WEBPACK FOOTER //
// src/pages/company/creden.vue